<template>
    <div>

        <section id="top-area" class="bg-light-cyan" style="display: none">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-6 p-0 pt-3 pb-3">
                        <div class="bg-white">
                            <apexchart width="100%" type="bar" :options="options" :series="series"></apexchart>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 p-0 pt-3 pb-3">
                        <div class="bg-white">
                            <apexchart width="100%" type="bar" :options="options" :series="series"></apexchart>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="main-area">
            <div class="container search-main pt-lg-5" >
                <bb-search-main></bb-search-main>
            </div>
        </section>
    </div>
</template>

<script>
    import { mdbModal, mdbModalBody, mdbBtn } from 'mdbvue';
    import findFlight from '@/components/findFlight';
    import sideBar from '@/components/sideBar';
    import searchMain from '@/components/searchMain';
    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            mdbModal,
            mdbModalBody,
            mdbBtn,
            'bb-findflight':findFlight,
            'bb-sidebar':sideBar,
            'bb-search-main':searchMain,
            'apexchart': VueApexCharts
        },
        data() {
            return {
                modal: false,
                toggle: false,
                options: {
                    chart: {
                        id: 'vuechart-example',
                        height: 200
                    },
                    xaxis: {
                        categories: ["19 Pzt", "20 Sal", "21 Çar", "22 Per", "23 Cum", "24 Cts", "25 Paz", "26 Pzt", "27 Pzt", "28 Pzt", "29 Pzt"]
                    }
                },
                series: [{
                    name: 'series-1',
                    data: [304, 240, 145, 500, 449, 260, 170, 491, 291, 191, 151]
                }]
            };
        },
        methods: {
            gotoSearch: function () {
                window.scrollTo(0, 450)
            }
        },
        mounted() {
            this.gotoSearch()
        }
    };
</script>

<style scoped>

</style>
